export default __webpack_public_path__ + "static/media/tavi_cube.eb9b0e3a.jpg";